/**
 * The name a duplicate takes: the source name plus "duplicate", then the
 * first free number after that. Names are compared case-insensitively
 * because svc-promo treats "Spring Sale" and "spring sale" as two rules an
 * operator would struggle to tell apart in the list. Case folding is locale
 * independent on purpose: toLocaleLowerCase would fold the same name
 * differently depending on the host locale (Turkish I → ı), so the same
 * rules could yield a different "first free" name per browser.
 */
export function getDuplicateMarketingRouterRuleName(originalName: string, existingNames: Iterable<string>): string {
  const baseName = `${originalName.trim()} duplicate`;
  const normalizedExistingNames = new Set(Array.from(existingNames, (name) => name.trim().toLowerCase()));

  if (!normalizedExistingNames.has(baseName.toLowerCase())) {
    return baseName;
  }

  let suffix = 2;
  while (normalizedExistingNames.has(`${baseName} ${suffix}`.toLowerCase())) {
    suffix += 1;
  }

  return `${baseName} ${suffix}`;
}
